import FastImage from 'react-native-fast-image';
import {RFValue} from 'react-native-responsive-fontsize';
import styled from 'styled-components/native';

export const Container = styled.TouchableOpacity`
  margin: 0 24px;
  border-radius: ${RFValue(12)}px;
`;

export const PanelImage = styled(FastImage)`
  width: 100%;
  height: ${RFValue(50)}px;
  border-radius: ${RFValue(12)}px;
`;
